import { useMutation } from "urql";

import { RejectLimitRequestByCuManagerDocument } from "../../../graphql/generated.ts";

export const useRejectLimitRequestByCUManager = () =>
  useMutation(RejectLimitRequestByCuManagerDocument);
